import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DownloadIcon from '../../../components/Icons/DownloadIcon';
import ClickableLink from '../../../components/Text/ClickableLink';

interface DownloadLinksProps {
  downloadCSV: () => void;
  downloadExcel: () => void;
}

function DownloadLinks({ downloadCSV, downloadExcel }: DownloadLinksProps) {
  const theme = useTheme();
  const [t] = useTranslation();

  return (
    <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center', alignSelf: 'right' }}>
      <DownloadIcon />
      <Typography fontSize="20px" variant="body2" lineHeight="normal">
        {t('pages.import.download')}
      </Typography>
      <ClickableLink
        sx={{
          fontSize: '20px',
          alignItems: 'center',
          color: theme.palette.state.linkHover,
          textDecorationColor: theme.palette.state.linkHover,
          '&.active': {
            color: theme.palette.state.linkHover,
          },
        }}
        onClick={downloadExcel}
        to=""
      >
        {t('pages.import.excel')}
      </ClickableLink>
      <Typography fontSize="20px" variant="body2" lineHeight="normal">
        |
      </Typography>
      <ClickableLink
        sx={{
          fontSize: '20px',
          alignItems: 'center',
          color: theme.palette.state.linkHover,
          textDecorationColor: theme.palette.state.linkHover,
          '&.active': {
            color: theme.palette.state.linkHover,
          },
        }}
        onClick={downloadCSV}
        to=""
      >
        {t('pages.import.csv')}
      </ClickableLink>
    </Box>
  );
}

export default DownloadLinks;
